import { useState } from "react";
import type { Scope } from "../../api/types";
import "./overlays.css";

/** "Editar/Excluir evento recorrente": this / this and following / all. */
export function ScopeDialog({ mode, onChoose, onCancel }: { mode: "edit" | "delete"; onChoose: (s: Scope) => void; onCancel?: () => void }) {
  const [scope, setScope] = useState<Scope>("this");
  const options: Array<[Scope, string]> = [
    ["this", "Este evento"],
    ["following", "Este e os eventos seguintes"],
    ["all", "Todos os eventos"]
  ];
  return (
    <div className="scrim" onPointerDown={(e) => e.target === e.currentTarget && onCancel?.()} data-keep-open>
      <div className="dialog" role="dialog" aria-label={mode === "edit" ? "Editar evento recorrente" : "Excluir evento recorrente"} style={{ width: 360 }}>
        <h2>{mode === "edit" ? "Editar evento recorrente" : "Excluir evento recorrente"}</h2>
        {options.map(([value, label]) => (
          <label key={value} className="rec-radio">
            <input type="radio" name="scope" checked={scope === value} onChange={() => setScope(value)} autoFocus={value === "this"} />
            {label}
          </label>
        ))}
        <div className="actions">
          <button className="btn text" onClick={onCancel}>
            Cancelar
          </button>
          <button className="btn primary" onClick={() => onChoose(scope)}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
